'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hourFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hourFromNow.js
// module id = 679
// module chunks = 0